import PartnerList from './index';

export default { path: '/home/partnerList', component: PartnerList };
